import { ContentData, ProductData } from "data/product/products";

export enum SWIPE_SLIDER_STYLES {
  LIGHT = "LIGHT",
  DARK = "DARK",
}

export interface PropsInterface {
  productData: ProductData;
  videos: ContentData[];
  styleType?: string;
}
